// グローバルcssの読み込み
import "assets/css/App.css";
import "assets/css/color.css";
import "assets/css/size.css";

import { RouterProvider } from "react-router-dom";

// store管理
import { StateMachineProvider, createStore } from "little-state-machine";
// store情報
import { STORE } from "stores/store.js";

import { memo } from "react";

// ルーター
import AppRoutes from "routes/AppRoutes";

// store作成
createStore(STORE, { name: "shch-mtmr" });

const App = memo(() => {
  return (
    <div>
      <StateMachineProvider>
        <RouterProvider router={AppRoutes} />
      </StateMachineProvider>
    </div>
  );
});

export default App;
